import spacing from 'material-ui/styles/spacing';
import typography from 'material-ui/styles/typography';
import { grey500, white, red500 } from 'material-ui/styles/colors';

const styles = {
  boxContainer: {
    minWidth: 320,
    maxWidth: 400,
    height: 'auto',
    position: 'absolute',
    top: '20%',
    left: 0,
    right: 0,
    margin: 'auto'
  },
  logoImg: {
    marginRight: 10,
    minWidth: 25
  },
  title: {
    fontSize: 22,
    lineHeight: `${spacing.desktopKeylineIncrement}px`,
    fontWeight: typography.fontWeightLight,
    height: 60
  },
  paper: {
    padding: 20,
    overflow: 'auto'
  },
  buttonsDiv: {
    textAlign: 'center',
    padding: 10
  },
  flatButton: {
    color: grey500
  },
  boxBtn: {
    float: 'right'
  },
  btn: {
    background: '#EF6A00',
    color: white,
    padding: 7,
    borderRadius: 2,
    margin: 2,
    fontSize: 13
  },

  btnSpan: {
    marginLeft: 5
  },
  buttonsContainer: {
    marginTop: 50,
    fontSize: '20px'
  },
  errorMessage: {
    color: red500
  },
  instructions: {
    textAlign: 'center',
    color: grey500
  },
  logoContainer: {
    textAlign: 'center',
    width: 360,
    height: 80,
    paddingTop: 20
  },
  logoImage: {
    width: 295,
    height: 54
  },
  logoSmallContainer: {
    position: 'absolute',
    right: 20,
    top: 20
  },
  version: {
    color: '#fff',
    fontWeight: '200',
    textAlign: 'center'
  },
  countryflag: {
    fontSize: '25px'
  }
};

export default styles;
